import React from 'react'
import styled from 'styled-components'
import {
  useCheckoutDiscountCode,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'
import { IconClose } from '../Icons'

export const PromoCodeList = () => {
  const { handleDiscountCodeRemove, appliedCodes } = useCheckoutDiscountCode()
  const { signs } = useGlobalLabels()
  const removeCode = (code: string) => () => {
    handleDiscountCodeRemove({ code })
  }

  return (
    <>
      {appliedCodes?.map((data) => {
        const { code } = data.discountCode.resource

        return (
          <PromoCodeCard key={`Code__${data.discountCode.resourceId}`}>
            <Code>{`${signs?.hashTag}${code}`}</Code>
            <RemoveContainer onClick={removeCode(code)}>
              <IconClose />
            </RemoveContainer>
          </PromoCodeCard>
        )
      }) || null}
    </>
  )
}

const Code = styled.span``

const RemoveContainer = styled.button.attrs({
  type: 'button',
  className: 'p-0',
})`
  background: 0 !important;
  width: 1rem !important;
  min-height: 0 !important;
  height: 1rem !important;
  line-height: 1 !important;

  & svg {
    width: 1rem;
    height: 1rem;
    fill: ${({ theme }) => theme.palette.secondary};
  }
`

const PromoCodeCard = styled.div.attrs({
  className: 'p-3',
})`
  background: ${({ theme }) => theme.palette.discounted};
  color: ${({ theme }) => theme.palette.secondary};
  border-radius: 0.4rem;

  display: flex;
  justify-content: space-between;

  margin-bottom: 0.8rem;
`
